import { useRouter } from '@mi-front/core';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { IconButton, IconButtonProps } from '@mui/material';

export interface NavigateRowActionProps {
  readonly to: string;
  readonly size?: IconButtonProps['size'];
}

export function NavigateRowAction({ to, size = 'small' }: NavigateRowActionProps) {
  const { history } = useRouter();

  return (
    <IconButton
      size={size}
      onClick={(e) => {
        e.stopPropagation();
        history.push(to);
      }}
    >
      <ChevronRightIcon fontSize={size} />
    </IconButton>
  );
}
